import React from 'react';
import AppBadge from './AppBadge';

export const APP_STATUS_PRESETS = {
  active: { variant: 'success', label: 'Actif' },
  inactive: { variant: 'secondary', label: 'Désactivé' },
  scheduled: { variant: 'info', label: 'Programmé' },
  expired: { variant: 'neutral', label: 'Expiré' },
  revoked: { variant: 'neutral', label: 'Révoqué' },
  invalid: { variant: 'danger', label: 'Inactif' },
};

const AppStatusBadge = ({ status = 'inactive', label, className = '', ...rest }) => {
  const preset = APP_STATUS_PRESETS[status] || APP_STATUS_PRESETS.inactive;
  return (
    <AppBadge variant={preset.variant} className={className} {...rest}>
      {label ?? preset.label}
    </AppBadge>
  );
};

export default AppStatusBadge;
